export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  triggered_broadcast: 'API-triggered broadcast',
  behavioral: 'Event triggered',
  seg_attr: 'Segment triggered',
  date: 'Date triggered',
  form: 'Form submitted',
  webhook: 'Webhook',
  transactional: 'Transactional',
  relationship: 'Relationship',
  object: 'Object',
  none: 'Campaign',
};

export const SEGMENT_TYPE_LABELS: Record<string, string> = {
  static: 'Manual',
  dynamic: 'Data-driven',
  temporary: 'Temporary',
  hidden: 'Hidden',
};
